import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import HomeView from '../views/HomeView.vue'
import AccountView from '../views/AccountView.vue'
import PoolSettingsView from '../views/PoolSettingsView.vue'
import MatchView from "../views/MatchView.vue";
import PlaceholderView from "../views/PlaceholderView.vue";
import VoteOverview from "../views/VoteOverview.vue";
import ChatView from '../views/ChatView.vue'
import ResetPasswordView from '../views/ResetPasswordView.vue'
import SettingsView from '../views/SettingsView.vue'
import PrivacyView from '../views/PrivacyView.vue'

const routes = [
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/account",
    name: "account",
    component: AccountView,
  },
  {
    path: "/pool-settings",
    name: "pool-settings",
    component: PoolSettingsView,
  },
  {
    path: "/match",
    name: "match",
    component: MatchView,
  },
  {
    path: "/placeholder",
    name: "placeholder",
    component: PlaceholderView,
  },
  {
    path: "/vote-overview",
    name: "vote-overview",
    component: VoteOverview,
  },
  {
    path: "/chat",
    name: "chat",
    component: ChatView,
  },
  {
    path: "/reset_password",
    name: "reset_password",
    component: ResetPasswordView,
  },
  {
    path: "/settings",
    name: "settings",
    component: SettingsView,
  },
  {
    path: "/privacy",
    name: "privacy",
    component: PrivacyView,
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
